export const newOrdersExpand = 'newOrdersExpand';
export const inProgressOrdersExpand = 'inProgressOrdersExpand';
export const historyOrdersExpand = 'historyOrdersExpand';
export const leftSidebar = 'leftSidebar';
export const rightSidebar = 'rightSidebar';


// WEBPACK FOOTER //
// ./src/constants/onDemandConstants.js